import { QuoteRequestStatusSchema } from "../types";
import { QuoteRequest } from "../types/QuoteRequest";

export const mockQuoteRequest: QuoteRequest = {
  id: "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11",
  status: QuoteRequestStatusSchema.enum.DRAFT,
  pdfFileUrl: null,
  targetPrice: null,
  nCompaniesRequested: null,
  foreignCompaniesRequested: null,
  alreadyManufacturedParts: null,
  certificationNeeded: null,
  skippedFollowUp: false,
  version: 1,
  isFavorite: null,
  salesMarginRatio: 0,
  processSteps: [],
  productLines: [],
};
